import {
   ADD_USER,
   GET_USER,
   GET_USER_BY_ID,
   UPDATE_USER_RIGHTS,
   USER_PROFILE,
   DELETE_USER,
   UPDATE_USER_HISTORY,
   IS_ERROR,
   GET_USERS,
   UPDATE_USER_STATUS,
   USER_GLOBAL_SETTINGS,
} from '../types';

const initialState = {
   list: [],
   single: null,
   profile: null,
   isError: null,
   users: null,
   pagination: null,
   totalCount: 0,
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_USER:
         return { ...state, list: payload || [] };

      case ADD_USER:
         return { ...state, single: payload || null };

      case GET_USERS:
         return { ...state, users: payload.data, pagination: payload.pagination, totalCount: payload.totalCount };

      case USER_PROFILE:
         return { ...state, profile: payload || null };

      case USER_GLOBAL_SETTINGS:
         return { ...state, globalSettings: payload || null };

      case GET_USER_BY_ID:
         return { ...state, single: payload };

      case UPDATE_USER_STATUS:
         return {
            ...state,
            list: state.list.map((user) => (user.id === payload.id ? { ...user, status: payload.status } : user)),
         };
      case UPDATE_USER_RIGHTS:
         return { ...state, userRights: payload };

      case IS_ERROR:
         return { ...state, isError: payload };

      case DELETE_USER:
         return { ...state, list: state.list.filter((user) => user.id !== payload) };
      case UPDATE_USER_HISTORY:
         return { ...state, profile: payload || null };

      default:
         return state;
   }
};

export default reducer;
